import { defineMessage } from '../../../services/localization';

export const messages = {
    xeroAdvancedBillToPOMatching: defineMessage('billtopo_matching'),
    xeroAdvancedBudgetChecking: defineMessage('budget_checking'),
    xeroAdvancedSupplierOnboarding: defineMessage('supplier_onboarding'),
    xeroAdvancedAutoApprovals: defineMessage('automated_approvals'),
    xeroAdvancedSalesQuoteApprovals: defineMessage('sales_quotation'),
    xeroAdvancedManualJournalApprovals: defineMessage('manual_journal_approvals'),
    xeroAdvancedGoodsReceivedNotes: defineMessage('goods_received_notes'),
    xeroAdvancedWorkflowVersionHistory: defineMessage('workflow_version_history'),
    xeroAdvancedRequestReviewStep: defineMessage('review_step'),
    xeroAdvancedAccrualReports: defineMessage('accrual_reports'),
    xeroAdvancedEditingOnApproval: defineMessage('editing_on_approval'),
    xeroAdvancedRequestVersionHistory: defineMessage('request_version_history'),
    xeroAdvancedHoldRequestOnApproval: defineMessage('hold_request_on_approval'),
    xeroAdvancedGroupOfAccounts: defineMessage('account_groups'),
    xeroPremiumBatchPaymentApprovals: defineMessage('xero_batch_payment_processing'),
    xeroPremiumPaymentsWithAirwallex: defineMessage('payments_with_airwallex'),
    xeroPremiumStandAloneWorkflows: defineMessage('standalone_workflows'),
    xeroPremiumPublicAPI: defineMessage('public_api'),
    xeroPremiumPrioritySupport: defineMessage('premium_support'),
    qboAdvancedBillToPOMatching: defineMessage('billtopo_matching'),
    qboAdvancedVendorOnboarding: defineMessage('vendor_onboarding'),
    qboAdvancedAutoApprovals: defineMessage('automated_approvals'),
    qboAdvancedJournalEntryApprovals: defineMessage('journal_entry_approvals'),
    qboAdvancedGoodsReceivedNotes: defineMessage('goods_received_notes'),
    qboAdvancedWorkflowVersionHistory: defineMessage('workflow_version_history'),
    qboAdvancedRequestReviewStep: defineMessage('review_step'),
    qboAdvancedRequestVersionHistory: defineMessage('request_version_history'),
    qboAdvancedHoldRequestOnApproval: defineMessage('hold_request_on_approval'),
    qboAdvancedBudgetChecking: defineMessage('budget_checking_beta'),
    qboPremiumStandAloneWorkflows: defineMessage('standalone_workflows'),
    qboPremiumPrioritySupport: defineMessage('premium_support'),
    qboPremiumPublicAPI: defineMessage('public_api'),
    addOnCaptureTitle: defineMessage('approvalmax_capture'),
    addOnPayTitle: defineMessage('approvalmax_pay'),
};
